export const ASYNC_FETCH = 'ITP_Review/ASYNC_FETCH';
export const ASYNC_FETCH_REVIEW_SUCCESS = 'ITP_Review/ASYNC_FETCH_REVIEW_SUCCESS';
export const ASYNC_FETCH_FAILURE = 'ITP_Review/ASYNC_FETCH_FAILURE';
export const ASYNC_FETCH_INVALIDATE = 'ITP_Review/ASYNC_FETCH_INVALIDATE';
export const SET_REVIEW_DATA = 'ITP_Review/SET_REVIEW_DATA';
export const SET_ISREVIEW_LOAD = 'ITP_Review/SET_ISREVIEW_LOAD';
export const SET_ISCHANGE_PLAN = 'ITP_Review/SET_ISCHANGE_PLAN';
/**
 * action types
 * @type {string}
 */
// export const formatPhoneNumber = (val) => { // eslint-disable-line
//   if (val !== '') {
//     return val.substring(0, 3) + '.' + val.substring(3, 6) + '.' + val.substring(6);
//   }
//   return val;
// };
